import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.PlanningProduct';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class PlanningProduct extends RpcClass{

    /**
     *  @class PlanningProduct
     *  @alias module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct
     *  
     * */
    constructor(){
        super();

        /** @type {BigDecimal}  */
        this.CBM = null;
        /** @type {string}  */
        this.EID = null;
        /** @type {string}  */
        this.VATRate = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}  */
        this.attachments = null;
        /** @type {LocalDate}  */
        this.confirmedETD = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {string}  */
        this.deliveryPort = null;
        /** @type {BigDecimal}  */
        this.duty = null;
        /** @type {boolean}  */
        this.existsInAnyOrderDetails = null;
        /** @type {string}  */
        this.id = null;
        /** @type {string}  */
        this.incoterms = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.initialPriceTargetCost = null;
        /** @type {boolean}  */
        this.isBulkSendInquiry = null;
        /** @type {boolean}  */
        this.isProductionPath = null;
        /** @type {boolean}  */
        this.isPurchasePath = null;
        /** @type {boolean}  */
        this.isSendInquiry = null;
        /** @type {number}  */
        this.minQuantity = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {number}  */
        this.numberOfOfferWhileBulkSendInquiry = null;
        /** @type {string}  */
        this.originCountry = null;
        /** @type {string}  */
        this.portOfShipment = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.price = null;
        /** @type {LocalDate}  */
        this.productInWarehousePlan = null;
        /** @type {string}  */
        this.productSeasonId = null;
        /** @type {number}  */
        this.quantityOuter = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.retailPrice = null;
        /** @type {string}  */
        this.supplierId = null;
        /** @type {boolean}  */
        this.targetSupplier = null;
        /** @type {string}  */
        this.transportType = null;
        /** @type {string}  */
        this.urlProduct = null;
        /** @type {string}  */
        this.uuid = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }



    /**
     * Get extension tab: Other Cost In Offer
     * @returns {Promise<OtherCostInOffer>}
     */

    async getOtherCostInOffer(){
        return Rpc.Forms.getEntityExtension(
            FULL_CLASS,
            this.id,
            "planningProductId",
            "com.silkplm.model.plm.OtherCostInOffer");
   }

    /**
     * Get list of detail Negotiation Planning
     * @returns {Promise<NegotiationPlanning[]>}
     */

    async listNegotiationPlanning(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.NegotiationPlanning",
        "planningId");
    }
    /**
     * Get list of detail Basic Cost In Offer
     * @returns {Promise<BasicCostInOffer[]>}
     */

    async listBasicCostInOffer(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.BasicCostInOffer",
        "planningProductId");
    }
    /**
     * Get list of detail Additional Cost In Offer
     * @returns {Promise<AdditionalCostInOffer[]>}
     */

    async listAdditionalCostInOffer(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.AdditionalCostInOffer",
        "planningProductId");
    }
    /**
     * Get list of detail Branding Calculation In Offer
     * @returns {Promise<BrandingCalculationInOffer[]>}
     */

    async listBrandingCalculationInOffer(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.BrandingCalculationInOffer",
        "planningProductId");
    }
    /**
     * Get list of detail Chat Message Base
     * @returns {Promise<ChatMessageBase[]>}
     */

    async listChatMessageBase(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.chat.ChatMessageBase",
        "planningProductId");
    }
    /**
     * Get list of detail Documents
     * @returns {Promise<InquiryTabCore[]>}
     */

    async listInquiryTabCore(){
    return Rpc.Forms.listDetails(
        FULL_CLASS,
        this.id,
        "com.silkplm.model.plm.tabInquiry.InquiryTabCore",
        "planningProductId");
    }

    /** @type {BigDecimal}  */
    get productSeasonIdProductIdCBM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdCBM'] : null, this.__metadata__['productSeasonIdProductIdCBM']?.remoteType);
    }
    set productSeasonIdProductIdCBM(val){
    }
    // fk: false

    /** @type {string}  */
    get productSeasonIdProductIdPM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdPM'] : null, this.__metadata__['productSeasonIdProductIdPM']?.remoteType);
    }
    set productSeasonIdProductIdPM(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductSeasonIdProductIdPMLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'productSeasonIdProductIdPM',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductSeasonIdProductIdPMStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'productSeasonIdProductIdPM'); //  false 
    }

    /** @returns {Promise<ApplicationUser>} */
    getProductSeasonIdProductIdPMEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'productSeasonIdProductIdPM',  allowRemote); //  false 
    }

    /** @type {string}  */
    get productSeasonIdVATRate(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdVATRate'] : null, this.__metadata__['productSeasonIdVATRate']?.remoteType);
    }
    set productSeasonIdVATRate(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductSeasonIdVATRateLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'productSeasonIdVATRate',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductSeasonIdVATRateStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'productSeasonIdVATRate'); //  false 
    }

    /** @returns {Promise<VatLevel>} */
    getProductSeasonIdVATRateEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.VatLevel', 'productSeasonIdVATRate',  allowRemote); //  false 
    }

    /** @type {string}  */
    get productSeasonIdProductIdCategory(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdCategory'] : null, this.__metadata__['productSeasonIdProductIdCategory']?.remoteType);
    }
    set productSeasonIdProductIdCategory(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductSeasonIdProductIdCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'productSeasonIdProductIdCategory',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductSeasonIdProductIdCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'productSeasonIdProductIdCategory'); //  false 
    }

    /** @returns {Promise<Category>} */
    getProductSeasonIdProductIdCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'productSeasonIdProductIdCategory',  allowRemote); //  false 
    }

    /** @type {string}  */
    get supplierIdCompanyFullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdCompanyFullName'] : null, this.__metadata__['supplierIdCompanyFullName']?.remoteType);
    }
    set supplierIdCompanyFullName(val){
    }
    // fk: false

    /** @type {string}  */
    get supplierIdCountry(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdCountry'] : null, this.__metadata__['supplierIdCountry']?.remoteType);
    }
    set supplierIdCountry(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getSupplierIdCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'supplierIdCountry',  allowRemote); //  false 
    }

    /** @returns {String} */
    getSupplierIdCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'supplierIdCountry'); //  false 
    }

    /** @returns {Promise<Country>} */
    getSupplierIdCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'supplierIdCountry',  allowRemote); //  false 
    }

    /** @type {string}  */
    get productSeasonIdDefaultEAN(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdDefaultEAN'] : null, this.__metadata__['productSeasonIdDefaultEAN']?.remoteType);
    }
    set productSeasonIdDefaultEAN(val){
    }
    // fk: false

    /** @type {string}  */
    get supplierIdDeliveryPort(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdDeliveryPort'] : null, this.__metadata__['supplierIdDeliveryPort']?.remoteType);
    }
    set supplierIdDeliveryPort(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getSupplierIdDeliveryPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'supplierIdDeliveryPort',  allowRemote); //  false 
    }

    /** @returns {String} */
    getSupplierIdDeliveryPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'supplierIdDeliveryPort'); //  false 
    }

    /** @returns {Promise<DeliveryPort>} */
    getSupplierIdDeliveryPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryPort', 'supplierIdDeliveryPort',  allowRemote); //  false 
    }

    /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
    get productSeasonIdProductIdGallery(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdGallery'] : null, this.__metadata__['productSeasonIdProductIdGallery']?.remoteType);
    }
    set productSeasonIdProductIdGallery(val){
    }
    // fk: false

    /** @type {string}  */
    get supplierIdIncoterms(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdIncoterms'] : null, this.__metadata__['supplierIdIncoterms']?.remoteType);
    }
    set supplierIdIncoterms(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getSupplierIdIncotermsLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Incoterms', 'supplierIdIncoterms',  allowRemote); //  false 
    }

    /** @returns {String} */
    getSupplierIdIncotermsStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Incoterms', 'supplierIdIncoterms'); //  false 
    }

    /** @returns {Promise<Incoterms>} */
    getSupplierIdIncotermsEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Incoterms', 'supplierIdIncoterms',  allowRemote); //  false 
    }

    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get productSeasonIdInitialPrice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdInitialPrice'] : null, this.__metadata__['productSeasonIdInitialPrice']?.remoteType);
    }
    set productSeasonIdInitialPrice(val){
    }
    // fk: false

    /** @type {boolean}  */
    get supplierIdIsAccountCreated(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdIsAccountCreated'] : null, this.__metadata__['supplierIdIsAccountCreated']?.remoteType);
    }
    set supplierIdIsAccountCreated(val){
    }
    // fk: false

    /** @type {module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]}  */
    get productSeasonIdProductIdMerchants(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdMerchants'] : null, this.__metadata__['productSeasonIdProductIdMerchants']?.remoteType);
    }
    set productSeasonIdProductIdMerchants(val){
    }
    // fk: false

    /** @type {string}  */
    get productSeasonIdProductIdName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdName'] : null, this.__metadata__['productSeasonIdProductIdName']?.remoteType);
    }
    set productSeasonIdProductIdName(val){
    }
    // fk: false

    /** @type {number}  */
    get productSeasonIdProductIdNumberOfProduct(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdNumberOfProduct'] : null, this.__metadata__['productSeasonIdProductIdNumberOfProduct']?.remoteType);
    }
    set productSeasonIdProductIdNumberOfProduct(val){
    }
    // fk: false

    /** @type {number}  */
    get productSeasonIdProductIdQuantityOuter(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdProductIdQuantityOuter'] : null, this.__metadata__['productSeasonIdProductIdQuantityOuter']?.remoteType);
    }
    set productSeasonIdProductIdQuantityOuter(val){
    }
    // fk: false

    /** @type {boolean}  */
    get supplierIdRemovedAndBlockedRoleSupplier(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdRemovedAndBlockedRoleSupplier'] : null, this.__metadata__['supplierIdRemovedAndBlockedRoleSupplier']?.remoteType);
    }
    set supplierIdRemovedAndBlockedRoleSupplier(val){
    }
    // fk: false

    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get productSeasonIdRetailPrice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdRetailPrice'] : null, this.__metadata__['productSeasonIdRetailPrice']?.remoteType);
    }
    set productSeasonIdRetailPrice(val){
    }
    // fk: false

    /** @type {string}  */
    get productSeasonIdSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdSeasonId'] : null, this.__metadata__['productSeasonIdSeasonId']?.remoteType);
    }
    set productSeasonIdSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductSeasonIdSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'productSeasonIdSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductSeasonIdSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'productSeasonIdSeasonId'); //  false 
    }

    /** @returns {Promise<Season>} */
    getProductSeasonIdSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'productSeasonIdSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get supplierIdShipmentPort(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdShipmentPort'] : null, this.__metadata__['supplierIdShipmentPort']?.remoteType);
    }
    set supplierIdShipmentPort(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getSupplierIdShipmentPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'supplierIdShipmentPort',  allowRemote); //  false 
    }

    /** @returns {String} */
    getSupplierIdShipmentPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'supplierIdShipmentPort'); //  false 
    }

    /** @returns {Promise<Port>} */
    getSupplierIdShipmentPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'supplierIdShipmentPort',  allowRemote); //  false 
    }

    /** @type {string}  */
    get productSeasonIdSubSeasonId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productSeasonIdSubSeasonId'] : null, this.__metadata__['productSeasonIdSubSeasonId']?.remoteType);
    }
    set productSeasonIdSubSeasonId(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductSeasonIdSubSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.SubSeason', 'productSeasonIdSubSeasonId',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductSeasonIdSubSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.SubSeason', 'productSeasonIdSubSeasonId'); //  false 
    }

    /** @returns {Promise<SubSeason>} */
    getProductSeasonIdSubSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.SubSeason', 'productSeasonIdSubSeasonId',  allowRemote); //  false 
    }

    /** @type {string}  */
    get supplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdSupplierCode'] : null, this.__metadata__['supplierIdSupplierCode']?.remoteType);
    }
    set supplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {*[]}  */
    get basicCostInPlanningProductList(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['basicCostInPlanningProductList'] : null, this.__metadata__['basicCostInPlanningProductList']?.remoteType);
    }
    set basicCostInPlanningProductList(val){
    }


    /** @type {string}  */
    get categoryFullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['categoryFullName'] : null, this.__metadata__['categoryFullName']?.remoteType);
    }
    set categoryFullName(val){
    }


    /** @type {LocalDate}  */
    get computedProductInWarehousePlanFromCalculation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedProductInWarehousePlanFromCalculation'] : null, this.__metadata__['computedProductInWarehousePlanFromCalculation']?.remoteType);
    }
    set computedProductInWarehousePlanFromCalculation(val){
    }


    /** @type {number}  */
    get computedTransportTypeFromCalculation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['computedTransportTypeFromCalculation'] : null, this.__metadata__['computedTransportTypeFromCalculation']?.remoteType);
    }
    set computedTransportTypeFromCalculation(val){
    }

    /** @returns {Promise<String>} */
    getComputedTransportTypeFromCalculationLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computedTransportTypeFromCalculation', allowRemote); //  true 
    }

    /** @returns {String} */
    getComputedTransportTypeFromCalculationStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'computedTransportTypeFromCalculation'); //  true 
    }

    /** @returns {Promise<TransportType>} */
    getComputedTransportTypeFromCalculationEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'computedTransportTypeFromCalculation',  allowRemote); //  true 
    }

    /** @type {BigDecimal}  */
    get dutyFromCalculation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['dutyFromCalculation'] : null, this.__metadata__['dutyFromCalculation']?.remoteType);
    }
    set dutyFromCalculation(val){
    }


    /** @type {boolean}  */
    get hasUnreadMessage(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['hasUnreadMessage'] : null, this.__metadata__['hasUnreadMessage']?.remoteType);
    }
    set hasUnreadMessage(val){
    }


    /** @type {string}  */
    get kindOfService(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['kindOfService'] : null, this.__metadata__['kindOfService']?.remoteType);
    }
    set kindOfService(val){
    }


    /** @type {BigDecimal}  */
    get margin(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['margin'] : null, this.__metadata__['margin']?.remoteType);
    }
    set margin(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get netCost(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['netCost'] : null, this.__metadata__['netCost']?.remoteType);
    }
    set netCost(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get productionCost(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productionCost'] : null, this.__metadata__['productionCost']?.remoteType);
    }
    set productionCost(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get purchasePriceLastNegotiation(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['purchasePriceLastNegotiation'] : null, this.__metadata__['purchasePriceLastNegotiation']?.remoteType);
    }
    set purchasePriceLastNegotiation(val){
    }


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withCBM(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.CBM = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withVATRate(val){
        this.VATRate = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getVATRateLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate', allowRemote); //  true 
    }

    /** @returns {String} */
        getVATRateStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate'); //  true 
    }

        /** @returns {Promise<VatLevel>} */
    getVATRateEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.VatLevel', 'VATRate', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withAttachments(val){
        this.attachments = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withConfirmedETD(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.confirmedETD = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withDeliveryPort(val){
        this.deliveryPort = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getDeliveryPortLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /** @returns {String} */
        getDeliveryPortStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort'); //  true 
    }

        /** @returns {Promise<DeliveryPort>} */
    getDeliveryPortEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.DeliveryPort', 'deliveryPort', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withDuty(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.duty = v;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withExistsInAnyOrderDetails(val){
        this.existsInAnyOrderDetails = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withIncoterms(val){
        this.incoterms = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getIncotermsLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Incoterms', 'incoterms', allowRemote); //  true 
    }

    /** @returns {String} */
        getIncotermsStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Incoterms', 'incoterms'); //  true 
    }

        /** @returns {Promise<Incoterms>} */
    getIncotermsEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Incoterms', 'incoterms', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withInitialPriceTargetCost(val){
        this.initialPriceTargetCost = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withIsBulkSendInquiry(val){
        this.isBulkSendInquiry = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withIsProductionPath(val){
        this.isProductionPath = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withIsPurchasePath(val){
        this.isPurchasePath = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withIsSendInquiry(val){
        this.isSendInquiry = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withMinQuantity(val){
        this.minQuantity = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withNumberOfOfferWhileBulkSendInquiry(val){
        this.numberOfOfferWhileBulkSendInquiry = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withOriginCountry(val){
        this.originCountry = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getOriginCountryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Country', 'originCountry', allowRemote); //  true 
    }

    /** @returns {String} */
        getOriginCountryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Country', 'originCountry'); //  true 
    }

        /** @returns {Promise<Country>} */
    getOriginCountryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Country', 'originCountry', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withPortOfShipment(val){
        this.portOfShipment = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPortOfShipmentLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Port', 'portOfShipment', allowRemote); //  true 
    }

    /** @returns {String} */
        getPortOfShipmentStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Port', 'portOfShipment'); //  true 
    }

        /** @returns {Promise<Port>} */
    getPortOfShipmentEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Port', 'portOfShipment', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withPrice(val){
        this.price = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withProductInWarehousePlan(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.productInWarehousePlan = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withProductSeasonId(val){
        this.productSeasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ProductInSeason', 'productSeasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ProductInSeason', 'productSeasonId'); //  true 
    }

        /** @returns {Promise<ProductInSeason>} */
    getProductSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ProductInSeason', 'productSeasonId', allowRemote); //  true 
    }

    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withQuantityOuter(val){
        this.quantityOuter = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withRetailPrice(val){
        this.retailPrice = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withSupplierId(val){
        this.supplierId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierId'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withTargetSupplier(val){
        this.targetSupplier = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withTransportType(val){
        this.transportType = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getTransportTypeLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.TransportType', 'transportType', allowRemote); //  true 
    }

    /** @returns {String} */
        getTransportTypeStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.TransportType', 'transportType'); //  true 
    }

        /** @returns {Promise<TransportType>} */
    getTransportTypeEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.TransportType', 'transportType', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withUrlProduct(val){
        this.urlProduct = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withUuid(val){
        this.uuid = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/PlanningProduct.PlanningProduct}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<PlanningProduct>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadPlanningProduct(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'productSeasonIdProductIdPM'){
            return this.getProductSeasonIdProductIdPMLabel(allowRemote);
        }
        if(fiendName === 'productSeasonIdVATRate'){
            return this.getProductSeasonIdVATRateLabel(allowRemote);
        }
        if(fiendName === 'productSeasonIdProductIdCategory'){
            return this.getProductSeasonIdProductIdCategoryLabel(allowRemote);
        }
        if(fiendName === 'supplierIdCountry'){
            return this.getSupplierIdCountryLabel(allowRemote);
        }
        if(fiendName === 'supplierIdDeliveryPort'){
            return this.getSupplierIdDeliveryPortLabel(allowRemote);
        }
        if(fiendName === 'supplierIdIncoterms'){
            return this.getSupplierIdIncotermsLabel(allowRemote);
        }
        if(fiendName === 'productSeasonIdSeasonId'){
            return this.getProductSeasonIdSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'supplierIdShipmentPort'){
            return this.getSupplierIdShipmentPortLabel(allowRemote);
        }
        if(fiendName === 'productSeasonIdSubSeasonId'){
            return this.getProductSeasonIdSubSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'VATRate'){
            return this.getVATRateLabel(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortLabel(allowRemote);
        }
        if(fiendName === 'incoterms'){
            return this.getIncotermsLabel(allowRemote);
        }
        if(fiendName === 'originCountry'){
            return this.getOriginCountryLabel(allowRemote);
        }
        if(fiendName === 'portOfShipment'){
            return this.getPortOfShipmentLabel(allowRemote);
        }
        if(fiendName === 'productSeasonId'){
            return this.getProductSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdLabel(allowRemote);
        }
        if(fiendName === 'transportType'){
            return this.getTransportTypeLabel(allowRemote);
        }
        if(fiendName === 'computedTransportTypeFromCalculation'){
            return this.getComputedTransportTypeFromCalculationLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'VATRate'){
            return this.getVATRateEntity(allowRemote);
        }
        if(fiendName === 'deliveryPort'){
            return this.getDeliveryPortEntity(allowRemote);
        }
        if(fiendName === 'incoterms'){
            return this.getIncotermsEntity(allowRemote);
        }
        if(fiendName === 'originCountry'){
            return this.getOriginCountryEntity(allowRemote);
        }
        if(fiendName === 'portOfShipment'){
            return this.getPortOfShipmentEntity(allowRemote);
        }
        if(fiendName === 'productSeasonId'){
            return this.getProductSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdEntity(allowRemote);
        }
        if(fiendName === 'transportType'){
            return this.getTransportTypeEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<PlanningProduct>}
 */
async function loadPlanningProduct(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<PlanningProduct[]>}
 */
async function listPlanningProduct(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelPlanningProduct(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<PlanningProduct>}
 */
PlanningProduct.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<PlanningProduct[]>}
 */
PlanningProduct.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<PlanningProduct[]>}
 */
PlanningProduct.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<PlanningProduct[]>}
 */
PlanningProduct.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<PlanningProduct>}
 */
PlanningProduct.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return PlanningProduct.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
PlanningProduct.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
PlanningProduct.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
PlanningProduct.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
PlanningProduct.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
PlanningProduct.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['CBM'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['VATRate'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['attachments'] = {'remoteType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'jsType' : 'module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository[]', 'mapped' : 'false'};
metadata['confirmedETD'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['deliveryPort'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['duty'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['existsInAnyOrderDetails'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['incoterms'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['initialPriceTargetCost'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['isBulkSendInquiry'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isProductionPath'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isPurchasePath'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['isSendInquiry'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['minQuantity'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['numberOfOfferWhileBulkSendInquiry'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['originCountry'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['portOfShipment'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['price'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productInWarehousePlan'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['productSeasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['quantityOuter'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['retailPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['supplierId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['targetSupplier'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['transportType'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['urlProduct'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['uuid'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['basicCostInPlanningProductList'] = {'computed' : true, 'remoteType' : '*[]', 'jsType' : '*[]', 'mapped' : 'false'};
metadata['categoryFullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['computedProductInWarehousePlanFromCalculation'] = {'computed' : true, 'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['computedTransportTypeFromCalculation'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['dutyFromCalculation'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['hasUnreadMessage'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['kindOfService'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['margin'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['netCost'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productionCost'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['purchasePriceLastNegotiation'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productSeasonIdProductIdCBM'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['productSeasonIdProductIdPM'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdVATRate'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdProductIdCategory'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdCompanyFullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdCountry'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdDefaultEAN'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdDeliveryPort'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdProductIdGallery'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['supplierIdIncoterms'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdInitialPrice'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['supplierIdIsAccountCreated'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['productSeasonIdProductIdMerchants'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]', 'mapped' : 'false'};
metadata['productSeasonIdProductIdName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdProductIdNumberOfProduct'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productSeasonIdProductIdQuantityOuter'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['supplierIdRemovedAndBlockedRoleSupplier'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['productSeasonIdRetailPrice'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productSeasonIdSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdShipmentPort'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productSeasonIdSubSeasonId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.PlanningProduct';
metadata.__type_short__ = 'PlanningProduct';
PlanningProduct.prototype.__metadata__ = metadata;

PlanningProduct.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/PlanningProduct */
export default PlanningProduct

export { PlanningProduct , loadPlanningProduct, listPlanningProduct, labelPlanningProduct }
